import { ButtonBase, Typography } from "@mui/material";
import { useItemGroups } from "../../../shared/hooks/useItemsData";
import GroupItem from "./GroupItem";
import { useState } from "react";
import { useStyles } from "../../style";

export default function GroupList({ onClick, ...other }) {
    const { isLoading, data, isFetching } = useItemGroups();
    const classes = useStyles();

    const [selectedGroup, setSelectedGroup] = useState(null);

    const handleClick = (group) => {
        console.log(group);
        setSelectedGroup(group.id);
        onClick(group);
    };

    return (
        <>
            {isLoading ? (
                <Typography variant="body2">Loading...</Typography>
            ) : data && data["All Item Groups"] ? (
                <>
                    <ButtonBase
                        style={{
                            height: "32px",
                            width: "100%",
                            flex: 1,
                            marginBottom: "1rem",
                        }}
                    >
                        <Typography variant="h8" onClick={handleClick}>
                            All Item Groups
                        </Typography>
                    </ButtonBase>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            height: "100%",
                            overflowY: "auto",
                        }}
                    >
                        {data["All Item Groups"].map((item) => (
                            <div
                                key={`Category_item_${item.name}`}
                                className={classes.PageWrap}
                            >
                                <GroupItem
                                    active={selectedGroup === item.id}
                                    group={item}
                                    onClick={handleClick}
                                />
                                <span>{item.name}</span>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <Typography variant="body2">No groups</Typography>
            )}
        </>
    );
}
